module.exports = __webpack_public_path__ + "static/uala-db3af17d226c5968b2c90a0fecbd7661.png";